import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { reportLanding } from './lib/api';
import { startFaultReporter } from './lib/telemetry';
import './index.css';

// Outside the tree on purpose: React 18 StrictMode mounts every effect twice in
// development, and the top-of-funnel counter is the one number that must not be
// double-counted by the framework measuring it. It is also fire-and-forget, so
// it has nothing to do with rendering and no reason to live in a component.
reportLanding();

// BEFORE `render`, and outside the tree, for the same reason as the line above
// and one more: this is what reports a fault in the render itself. A reporter
// mounted by React cannot witness React failing to mount.
startFaultReporter();

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
